import axios from '@/util/request'
const prefix = '/mkt/api/v1'

const busCoupon = {
}

export default busCoupon
